var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6336,
    cy: 25.0003,
    r: 20.8333,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1885 14.879C20.1885 16.176 19.201 17.2256 17.6567 17.2256C16.1725 17.2256 15.185 16.176 15.2155 14.879C15.185 13.519 16.1725 12.5 17.6863 12.5C19.201 12.5 20.1589 13.519 20.1885 14.879ZM15.3397 34.1865V19.0794H20.0348V34.1856H15.3397V34.1865Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7985 23.9009C23.7985 22.0166 23.7364 20.4102 23.6743 19.0817H27.7524L27.9692 21.1513H28.0619C28.6798 20.1934 30.2241 18.7427 32.7264 18.7427C35.8151 18.7427 38.132 20.7817 38.132 25.2285V34.1888H33.4369V25.8168C33.4369 23.8694 32.7579 22.5419 31.0588 22.5419C29.7609 22.5419 28.9892 23.4377 28.6808 24.3021C28.5566 24.6115 28.4955 25.0432 28.4955 25.4768V34.1888H23.8004V23.9009H23.7985Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footerLinkedin.153666af99046cbc11f1c3359d5a36cf.svg";
export { ForwardRef as ReactComponent };